import * as tslib_1 from "tslib";
import { Store } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of, zip } from 'rxjs';
import { switchMap, catchError, mergeMap, withLatestFrom } from 'rxjs/operators';
import { Selectors } from '../root-reducer';
import { RecordActionTypes, GetRecordsSuccess, GetRecordsFailure, GetIndividualRecord, GetIndividualRecordSuccess, GetIndividualRecordFailure, GetCorporateRecord, GetCorporateRecordSuccess, GetCorporateRecordFailure, ClearGetPrimaryCrpRecord, AddCrpRoleFailure, AddCrpRoleSuccess, DeleteCrpSuccess, DeleteCrpFailure, DeleteRoleFailure, DeleteRoleSuccess, GetCrpRolesFailure, GetCrpRolesSuccess, GetOtherData, GetOtherDataSuccess, GetOtherDataFailure } from '../actions/record.action';
import { ReloadCrpList } from 'store/actions/customer.actions';
import { RecordService } from 'modules/core/services/record.service';
import { CrpService } from 'modules/core/services/crp.service';
import { CustomerService } from 'modules/core/services/customer.service';
var RecordEffects = /** @class */ (function () {
    function RecordEffects(actions$, store, recordService, crpService, customerService) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.recordService = recordService;
        this.crpService = crpService;
        this.customerService = customerService;
        this.getRecords$ = this.actions$.pipe(ofType(RecordActionTypes.GET_RECORDS), mergeMap(function (res) {
            return _this.recordService.getRecords(res.payload).pipe(switchMap(function (record) {
                return of(new GetRecordsSuccess(record));
            }), catchError(function (error) {
                return of(new GetRecordsFailure(error.message));
            }));
        }));
        this.getIndividualRecord$ = this.actions$.pipe(ofType(RecordActionTypes.GET_INDIVIDUAL_RECORD), withLatestFrom(this.store.select(Selectors.customer.getCustomer)), mergeMap(function (_a) {
            var res = _a[0], customer = _a[1];
            return _this.recordService.getIndividualRecord(res.payload.recordId).pipe(switchMap(function (record) {
                var actions$ = [];
                if (res.payload && res.payload.getOtherData) {
                    if (customer) {
                        actions$.push(new GetOtherData({ record: record.id, customer: customer.id }));
                    }
                    else if (res.payload.customerId) {
                        actions$.push(new GetOtherData({ record: record.id, customer: res.payload.customerId }));
                    }
                }
                actions$.push(new GetIndividualRecordSuccess(record));
                return actions$;
            }), catchError(function (error) {
                return of(new GetIndividualRecordFailure(error.message));
            }));
        }));
        this.getCorporateRecord$ = this.actions$.pipe(ofType(RecordActionTypes.GET_CORPORATE_RECORD), withLatestFrom(this.store.select(Selectors.customer.getCustomer)), mergeMap(function (_a) {
            var res = _a[0], customer = _a[1];
            return _this.recordService.getCorporateRecord(res.payload.recordId).pipe(switchMap(function (record) {
                var actions$ = [];
                if (res.payload && res.payload.getOtherData) {
                    if (customer) {
                        actions$.push(new GetOtherData({ record: record.id, customer: customer.id }));
                    }
                    else if (res.payload.customerId) {
                        actions$.push(new GetOtherData({ record: record.id, customer: res.payload.customerId }));
                    }
                }
                actions$.push(new GetCorporateRecordSuccess(record));
                return actions$;
            }), catchError(function (error) {
                return of(new GetCorporateRecordFailure(error.message));
            }));
        }));
        this.GetPrimaryCrpRecord$ = this.actions$.pipe(ofType(RecordActionTypes.GET_PRIMARY_CRP_RECORD), withLatestFrom(this.store.select(Selectors.customer.getCustomer)), switchMap(function (_a) {
            var input = _a[0], customer = _a[1];
            if (customer && customer.id === input.payload.customerId) {
                return zip(of(input.payload), of(customer), _this.store.select(Selectors.customer.getCrps));
            }
            else {
                return zip(of(input.payload), _this.customerService.getCustomer(input.payload.customerId), _this.store.select(Selectors.customer.getCrps));
            }
        }), switchMap(function (_a) {
            var payload = _a[0], customer = _a[1], crps = _a[2];
            if (crps && crps.count) {
                return zip(of(payload), of(customer), of(crps));
            }
            else {
                return zip(of(payload), of(customer), _this.customerService.getCustomerCrps({ customerId: customer.id }));
            }
        }), switchMap(function (_a) {
            var payload = _a[0], customer = _a[1], crps = _a[2];
            var primaryCrp = crps.results.find(function (crp) { return crp.primary === true; });
            if (primaryCrp) {
                var actions$ = [];
                if (primaryCrp.recordType === 'INDIVIDUAL') {
                    actions$.push(new GetIndividualRecord({
                        recordId: primaryCrp.record,
                        getOtherData: payload.getOtherData
                    }));
                }
                else {
                    actions$.push(new GetCorporateRecord({
                        recordId: primaryCrp.record,
                        getOtherData: payload.getOtherData
                    }));
                }
                return actions$;
            }
            else {
                return of(new ClearGetPrimaryCrpRecord());
            }
        }));
        this.addCrpRole$ = this.actions$.pipe(ofType(RecordActionTypes.ADD_CRP_ROLE), mergeMap(function (res) {
            return _this.crpService.addCrpRole(res.payload).pipe(switchMap(function (role) {
                return of(new AddCrpRoleSuccess(role));
            }), catchError(function (error) {
                return of(new AddCrpRoleFailure(error.message));
            }));
        }));
        this.deleteCrp$ = this.actions$.pipe(ofType(RecordActionTypes.DELETE_CRP), mergeMap(function (res) {
            return zip(of(res.payload), _this.crpService.deleteCrp(res.payload)).pipe(mergeMap(function (_a) {
                var crpId = _a[0], deleteResponse = _a[1];
                return [
                    new DeleteCrpSuccess(deleteResponse),
                    new ReloadCrpList(deleteResponse)
                ];
            }), catchError(function (error) {
                return of(new DeleteCrpFailure(error.message));
            }));
        }));
        this.deleteRole$ = this.actions$.pipe(ofType(RecordActionTypes.DELETE_ROLE), mergeMap(function (res) {
            return _this.crpService.deleteRole(res.payload).pipe(switchMap(function (role) {
                return of(new DeleteRoleSuccess(role));
            }), catchError(function (error) {
                return of(new DeleteRoleFailure(error.message));
            }));
        }));
        this.getCrpRoles$ = this.actions$.pipe(ofType(RecordActionTypes.GET_CRP_ROLES), mergeMap(function (res) {
            return _this.crpService.getCrpRoles(res.payload).pipe(switchMap(function (role) {
                return of(new GetCrpRolesSuccess(role));
            }), catchError(function (error) {
                return of(new GetCrpRolesFailure(error.message));
            }));
        }));
        this.getOtherData$ = this.actions$.pipe(ofType(RecordActionTypes.GET_OTHER_DATA), mergeMap(function (res) {
            return _this.recordService.getOtherData(res.payload).pipe(switchMap(function (recordOtherDataResponse) {
                return of(new GetOtherDataSuccess(recordOtherDataResponse));
            }), catchError(function (error) {
                return of(new GetOtherDataFailure(error.message));
            }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RecordEffects.prototype, "getRecords$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RecordEffects.prototype, "getIndividualRecord$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RecordEffects.prototype, "getCorporateRecord$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RecordEffects.prototype, "GetPrimaryCrpRecord$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RecordEffects.prototype, "addCrpRole$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RecordEffects.prototype, "deleteCrp$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RecordEffects.prototype, "deleteRole$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RecordEffects.prototype, "getCrpRoles$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RecordEffects.prototype, "getOtherData$", void 0);
    return RecordEffects;
}());
export { RecordEffects };
